import React, { useEffect, useState } from "react";
import api from "../../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MarkTypesPage = () => {
  const [markTypes, setMarkTypes] = useState([]);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    title: "",
    short_code: "",
    order_no: 1,
    is_required: "1",
    has_pass: "1",
  });

  const listURL = "/mark-types/list";
  const createURL = "/mark-types/create";
  const updateURL = "/mark-types/update";

  useEffect(() => {
    fetchMarkTypes();
  }, []);

  const fetchMarkTypes = async () => {
    try {
      const res = await api.get(listURL);
      setMarkTypes(res.data?.data || []);
    } catch {
      toast.error("Failed to load mark types ❌");
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.title.trim()) return toast.error("Title is required ❌");

    try {
      let res;

      if (editId) {
        res = await api.post(`${updateURL}/${editId}`, form);
      } else {
        res = await api.post(createURL, form);
      }

      if (res.data.status) {
        toast.success(res.data.message);

        setForm({
          title: "",
          short_code: "",
          order_no: 1,
          is_required: "1",
          has_pass: "1",
        });

        setEditId(null);
        fetchMarkTypes();
      } else toast.error(res.data.message);
    } catch {
      toast.error("Network error ❌");
    }
  };

  const handleEdit = (row) => {
    setEditId(row.id);

    setForm({
      title: row.title,
      short_code: row.short_code || "",
      order_no: row.order_no,
      is_required: String(row.is_required),
      has_pass: String(row.has_pass),
    });

    window.scrollTo({ top: 0, behavior: "smooth" });
    toast.info("Edit Mode Enabled ✏️");
  };

  return (
    <div className="mt-container">
      <ToastContainer />


      {/* FORM CARD */}
      <div className="mt-card">
        <h2 className="mt-card-title">{editId ? "✏️ Edit Mark Type" : "➕ Add Mark Type"}</h2>

        <form onSubmit={handleSubmit} className="mt-form">

          <FormInput label="Title">
            <input
              className="mt-input"
              name="title"
              value={form.title}
              onChange={handleChange}
              placeholder="Written / Oral / Practical"
            />
          </FormInput>

          <FormInput label="Short Code (optional)">
            <input
              className="mt-input"
              name="short_code"
              value={form.short_code}
              onChange={handleChange}
              placeholder="W / O / P"
            />
          </FormInput>

          <FormInput label="Order No">
            <input
              className="mt-input"
              type="number"
              name="order_no"
              min="1"
              value={form.order_no}
              onChange={handleChange}
            />
          </FormInput>

          <FormInput label="Required?">
            <select
              name="is_required"
              className="mt-input"
              value={form.is_required}
              onChange={handleChange}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </FormInput>

          <FormInput label="Has Pass Mark?">
            <select
              name="has_pass"
              className="mt-input"
              value={form.has_pass}
              onChange={handleChange}
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </FormInput>

          <button className="mt-save-btn">{editId ? "Update" : "Save"}</button>
        </form>
      </div>

      {/* TABLE CARD */}
      <div className="mt-card">
        <h2 className="mt-card-title">📋 Mark Types List</h2>

        <table className="mt-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Short</th>
              <th>Order</th>
              <th>Required</th>
              <th>Has Pass</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {markTypes.length > 0 ? (
              markTypes.map((r) => (
                <tr key={r.id}>
                  <td>{r.title}</td>
                  <td>{r.short_code || "-"}</td>
                  <td>{r.order_no}</td>
                  <td>{r.is_required == 1 ? "Yes" : "No"}</td>
                  <td>{r.has_pass == 1 ? "Yes" : "No"}</td>
                  <td>
                    <button className="mt-edit-btn" onClick={() => handleEdit(r)}>Edit</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="6" className="mt-no-data">No Mark Types Found</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* CSS */}
      <style>{`
        .mt-container {
          padding: 20px;
          background: #f6f9ff;
          min-height: 100vh;
          font-family: 'Poppins', sans-serif;
        }


        .mt-card {
          background: white;
          border-radius: 18px;
          padding: 30px;
          margin: auto;
          max-width: 700px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.08);
          margin-bottom: 40px;
        }

        .mt-card-title {
          text-align: center;
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 25px;
        }

        .mt-form {
          display: flex;
          flex-direction: column;
          gap: 18px;
        }

        .mt-input {
          width: 100%;
          padding: 12px 14px;
          border-radius: 10px;
          border: 1px solid #d1d5db;
          font-size: 14px;
        }

        .mt-input:focus {
          border-color: #2563eb;
          box-shadow: 0 0 0 2px rgba(37,99,235,0.2);
          outline: none;
        }

        .mt-save-btn {
          background: #2563eb;
          color: white;
          padding: 12px;
          border: none;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 10px;
          box-shadow: 0 4px 12px rgba(37,99,235,0.4);
        }

        .mt-table {
          width: 100%;
          border-collapse: collapse;
        }

        .mt-table th {
          background: #2563eb;
          color: white;
          padding: 12px;
          text-align: left;
        }

        .mt-table td {
          padding: 12px;
          border-bottom: 1px solid #eee;
        }

        .mt-edit-btn {
          background: #2563eb;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
        }

        .mt-no-data {
          text-align: center;
          padding: 20px;
        }
      `}</style>
    </div>
  );
};

const FormInput = ({ label, children }) => (
  <div>
    <label style={{ fontWeight: 600 }}>{label}</label>
    {children}
  </div>
);

export default MarkTypesPage;
